<template>
  <div id="useCoupon">
    <kendo-grid ref="grid"
                :auth="true"
                :columns="tableFields"
                :dataUrl="tableUrl"
                :options="tableOptions"
                :size="'none'"
                :message="'쿠폰 사용 내역이 없습니다.'">
    </kendo-grid>
    <fab :linkList="fabLinkList" @download="download()"></fab>
  </div>
</template>

<script>
  import Fab from '@/components/admin/Fab'
  import KendoGrid from 'common/components/KendoGrid'

  export default {
    name: 'use-coupon',
    components: {
      Fab,
      KendoGrid
    },
    data () {
      return {
        fabLinkList: [
          {
            id: 'download',
            tooltip: '다운로드',
            callback: 'download',
            src: require('../../assets/svg/ic-download.svg')
          }
        ],
        tableFields: [
          {
            field: 'id',
            title: '번호',
            type: 'string',
            width: '80px'
          },
          {
            field: 'reg_date',
            title: '이용등록일',
            type: 'date',
            width: '120px',
            filterable: {
              operators: {
                date: {
                  and: '부터',
                  eq: '같음',
                  gte: '이후',
                  lte: '이전'
                }
              }
            },
            format: '{0:yyyy.MM.dd}'
          },
          {
            field: 'coupon__reg_date',
            title: '쿠폰함등록일',
            type: 'date',
            width: '120px',
            filterable: {
              operators: {
                date: {
                  and: '부터',
                  eq: '같음',
                  gte: '이후',
                  lte: '이전'
                }
              }
            },
            format: '{0:yyyy.MM.dd}'
          },
          {
            field: 'expiration_date',
            title: '이용종료일',
            type: 'date',
            filterable: {
              operators: {
                date: {
                  and: '부터',
                  eq: '같음',
                  gte: '이후',
                  lte: '이전'
                }
              }
            },
            width: '120px',
            template (item) {
              return item.expiration_date === null ? '-' : kendo.toString(kendo.parseDate(item.expiration_date), 'yyyy.MM.dd')
            }
          },
          {
            field: 'reg_by__first_name',
            title: '회원사명',
            type: 'string',
            attributes: { class: 'show-tooltip' },
            filterable: { multi: true, search: true },
            width: '200px'
          },
          {
            field: 'type_string',
            title: '구분',
            type: 'string',
            filterable: { multi: true, search: true },
            width: '120px'
          },
          {
            field: 'product_name',
            title: '이름',
            type: 'string',
            attributes: { class: 'show-tooltip' },
            filterable: { multi: true, search: true },
            width: '200px',
            template (item) {
              return item.product_name === '' ? '-' : item.product_name
            }
          },
          {
            field: 'product_desc',
            title: '내용',
            type: 'string',
            width: '200px',
            attributes: { class: 'show-tooltip' },
            sortable: false,
            filterable: false,
            template (item) {
              return item.product_desc === '' ? '-' : item.product_desc
            }
          },
          {
            field: 'period',
            title: '이용기간',
            type: 'string',
            width: '150px',
            filterable: { multi: true, search: true },
            template (item) {
              return item.period === '' ? '-' : `${item.period}일`
            }
          },
          {
            field: 'rest_days',
            title: '잔여기간',
            type: 'string',
            width: '150px',
            sortable: false,
            filterable: false,
            template (item) {
              return item.rest_days === '' ? '-' : `${item.rest_days}일`
            }
          },
          {
            field: 'point',
            title: '출력가능횟수',
            type: 'string',
            width: '150px',
            filterable: { multi: true, search: true },
            template (item) {
              return item.point === '' ? '-' : `${item.point}회`
            }
          },
          {
            field: 'coupon__promotion_code',
            title: '쿠폰코드',
            type: 'string',
            width: '150px',
            filterable: { extra: false },
            template (item) {
              return item.type === 'paid' ? '-'
                : item.coupon__promotion_code === '' ? '-'
                  : item.coupon__promotion_code
            }
          },
          {
            field: 'coupon__memo',
            title: '관리자메모',
            type: 'string',
            width: '250px',
            attributes: { class: 'show-tooltip' },
            filterable: { extra: false },
            template (item) {
              return item.type === 'paid' ? '-'
                : item.coupon__memo === '' ? '-'
                  : item.coupon__memo
            }
          },
          {
            field: 'coupon__reg_by__first_name',
            title: '쿠폰발행자',
            type: 'string',
            width: '150px',
            filterable: { multi: true, search: true },
            template (item) {
              return item.coupon__reg_by__first_name === null ? '-' : item.coupon__reg_by__first_name
            }
          }
        ],
        tableOptions: {
          excel: {
            fileName: `${moment().format('YYMMDD')}_use_coupon.xlsx`
          },
          pageable: {
            info: true,
            previousNext: true,
            numeric: true,
            pageSize: 100,
            pageSizes: [50, 100, 500, 'all'],
            refresh: true,
            buttonCount: 5,
            messages: {
              itemsPerPage: '페이지당 항목수'
            }
          },
          filterMenuInit: function (e) {
            // 기간검색 필터 일 경우
            if (['reg_date', 'coupon__reg_date', 'expiration_date'].includes(e.field)) {
              const firstValueDropDown = e.container.find('select:eq(0)').data('kendoDropDownList')
              firstValueDropDown.value('gte')
              firstValueDropDown.trigger('change')

              const secondValueDropDown = e.container.find('select:eq(2)').data('kendoDropDownList')
              secondValueDropDown.value('lte')
              secondValueDropDown.trigger('change')
            }
            // 단일검색 필터 일 경우
            if (['coupon__promotion_code', 'coupon__memo'].includes(e.field)) {
              const firstValueDropDown = e.container.find('select:eq(0)').data('kendoDropDownList')
              firstValueDropDown.value('contains')
              firstValueDropDown.trigger('change')
            }
          }
        },
        tableUrl: `${location.protocol}//${location.hostname.replace('biz', 'api')}/biz/pricing/charge-all/`
      }
    },
    methods: {
      download () {
        this.$refs.grid.download()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/UseCoupon.vue